import { createSvgIcon } from '@mui/material';
import Styled from "./custom-styled-icon";

export const Replace = Styled(
  createSvgIcon(
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.33284 2L10.9595 3.56002L5.65951 3.54667C3.27951 3.54667 1.32617 5.50002 1.32617 7.89335C1.32617 9.08668 1.81283 10.1733 2.5995 10.96"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M6.66573 13.9991L5.03906 12.439L10.3391 12.4524C12.7191 12.4524 14.6724 10.499 14.6724 8.10571C14.6724 6.91238 14.1857 5.82573 13.3991 5.03906"
        stroke="currentColor"
        stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M6 8H10"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>,
    
    "Replace",
  ),
);

export default Replace;
